import { z } from 'zod'
import { attemptOutcome } from './attempt.ts'
import { puzzleId } from './puzzle.ts'

export const recentAttempt = z.object({
  puzzleId,
  outcome: attemptOutcome,
  puzzleRating: z.number().int(),
  ratingAfter: z.number().int(),
  ratingDelta: z.number().int(),
  finishedAt: z.date(),
})

export const userStats = z.object({
  rating: z.number().int(),
  ratingDeviation: z.number().int(),
  /** True while the rating is still settling and shouldn't be taken seriously. */
  provisional: z.boolean(),
  attempted: z.number().int().min(0),
  solved: z.number().int().min(0),
  /** 0–1, null until there is at least one finished attempt. */
  solveRate: z.number().min(0).max(1).nullable(),
  currentStreak: z.number().int().min(0),
  bestStreak: z.number().int().min(0),
  recent: z.array(recentAttempt),
})

export type UserStats = z.infer<typeof userStats>
